export const interval = 10 * 60 * 1000; // eslint-disable-line import/prefer-default-export
